export default "__VITE_ASSET__DVwywK5h__";